(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require(undefined));
	else if(typeof define === 'function' && define.amd)
		define(["plesk-ui-library"], factory);
	else if(typeof exports === 'object')
		exports["Jsw"] = factory(require(undefined));
	else
		root["Jsw"] = factory(root[undefined]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 169);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/* no static exports found */
/* all exports used */
/*!*******************************************!*\
  !*** external {"amd":"plesk-ui-library"} ***!
  \*******************************************/
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),

/***/ 114:
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./app/promo/Promo.js ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _uiLibrary = __webpack_require__(/*! @plesk/ui-library */ 0);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var Promo = function (_Component) {
    _inherits(Promo, _Component);

    function Promo(props) {
        _classCallCheck(this, Promo);

        var _this = _possibleConstructorReturn(this, (Promo.__proto__ || Object.getPrototypeOf(Promo)).call(this, props));

        _this.state = {
            items: _this.props.items,
            width: null,
            currentPage: 0
        };

        _this.handleNextPage = _this.handleNextPage.bind(_this);
        _this.handlePrevPage = _this.handlePrevPage.bind(_this);
        _this.handleCloseItem = _this.handleCloseItem.bind(_this);
        _this.handleResize = _this.handleResize.bind(_this);
        return _this;
    }

    _createClass(Promo, [{
        key: "handleNextPage",
        value: function handleNextPage() {
            var currentPage = this.state.currentPage;


            currentPage++;
            if (currentPage > this.getCountPages() - 1) {
                currentPage = 0;
            }

            this.setState({ currentPage: currentPage });
        }
    }, {
        key: "handlePrevPage",
        value: function handlePrevPage() {
            var currentPage = this.state.currentPage;


            currentPage--;
            if (currentPage < 0) {
                currentPage = this.getCountPages() - 1;
            }

            this.setState({ currentPage: currentPage });
        }
    }, {
        key: "handleCloseItem",
        value: function handleCloseItem(item) {
            var currentPage = this.state.currentPage;

            var items = [].concat(_toConsumableArray(this.state.items));
            items.splice(items.indexOf(item), 1);

            if (currentPage * this.getRows() >= items.length) {
                currentPage--;
            }

            this.setState({ items: items, currentPage: currentPage });
            if (this.props.onCloseItem) {
                this.props.onCloseItem(item);
            }
            if (!items.length && this.props.onCloseLastItem) {
                this.props.onCloseLastItem();
            }
        }
    }, {
        key: "handleResize",
        value: function handleResize(contentRect) {
            this.setState({
                width: contentRect.bounds.width
            });
        }
    }, {
        key: "getCurrentItems",
        value: function getCurrentItems() {
            var current = this.state.currentPage * this.getRows();
            return this.state.items.slice(current, current + this.getRows());
        }
    }, {
        key: "getCountPages",
        value: function getCountPages() {
            return Math.ceil(this.state.items.length / this.getRows());
        }
    }, {
        key: "getRows",
        value: function getRows() {
            return Math.max(Math.floor(this.state.width / 300), 1);
        }
    }, {
        key: "renderItem",
        value: function renderItem(item, key) {
            var _this2 = this;

            var buttonUrl = item.buttonUrl,
                buttonTarget = item.buttonTarget,
                buttonText = item.buttonText,
                iconUrl = item.iconUrl,
                title = item.title,
                text = item.text,
                hideText = item.hideText;


            return (0, _uiLibrary.createElement)(
                "div",
                { className: "tools-item tools-item-active", key: key },
                (0, _uiLibrary.createElement)(
                    "a",
                    { className: "tool-block", href: buttonUrl, target: buttonTarget },
                    (0, _uiLibrary.createElement)(
                        "span",
                        { className: "tool-icon" },
                        (0, _uiLibrary.createElement)("img", { src: iconUrl })
                    ),
                    (0, _uiLibrary.createElement)(
                        "span",
                        { className: "tool-name" },
                        title
                    ),
                    (0, _uiLibrary.createElement)(
                        "span",
                        { className: "tool-info" },
                        text
                    )
                ),
                (0, _uiLibrary.createElement)(
                    "div",
                    { className: "tool-actions" },
                    (0, _uiLibrary.createElement)(
                        "a",
                        { href: buttonUrl, className: "btn", target: buttonTarget },
                        buttonText
                    ),
                    (0, _uiLibrary.createElement)(
                        "a",
                        { className: "link-02", onClick: function onClick() {
                                return _this2.handleCloseItem(item);
                            } },
                        (0, _uiLibrary.createElement)(
                            "span",
                            null,
                            hideText
                        )
                    )
                )
            );
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                className = _props.className,
                baseClassName = _props.baseClassName,
                title = _props.title;

            var items = this.getCurrentItems();

            if (!items.length) {
                return null;
            }

            var countPages = this.getCountPages();

            return (0, _uiLibrary.createElement)(
                "div",
                { className: (0, _uiLibrary.classNames)(baseClassName, className) },
                title && (0, _uiLibrary.createElement)(
                    "div",
                    { className: "p-box-header" },
                    (0, _uiLibrary.createElement)(
                        "div",
                        { className: "p-box-header-text" },
                        title
                    )
                ),
                (0, _uiLibrary.createElement)(
                    "div",
                    { className: "p-box-content" },
                    (0, _uiLibrary.createElement)(
                        _uiLibrary.Measure,
                        { onResize: this.handleResize, bounds: true },
                        function (_ref) {
                            var measureRef = _ref.measureRef;
                            return (0, _uiLibrary.createElement)(
                                "ul",
                                { ref: measureRef, className: "tools-list" },
                                items.map(function (item, key) {
                                    return _this3.renderItem(item, key);
                                })
                            );
                        }
                    )
                ),
                countPages > 1 && (0, _uiLibrary.createElement)(
                    "div",
                    { className: "p-box-footer" },
                    (0, _uiLibrary.createElement)(
                        "div",
                        { className: "p-box-footer-nav" },
                        (0, _uiLibrary.createElement)(
                            "a",
                            { className: "prev-link", onClick: this.handlePrevPage },
                            (0, _uiLibrary.createElement)(
                                "span",
                                null,
                                (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: "prev" })
                            )
                        ),
                        ' ',
                        (0, _uiLibrary.createElement)(
                            "a",
                            { className: "next-link", onClick: this.handleNextPage },
                            (0, _uiLibrary.createElement)(
                                "span",
                                null,
                                (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: "next" })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Promo;
}(_uiLibrary.Component);

Promo.propTypes = {
    items: _uiLibrary.PropTypes.array.isRequired,
    baseClassName: _uiLibrary.PropTypes.string,
    className: _uiLibrary.PropTypes.string,
    title: _uiLibrary.PropTypes.string,
    onCloseItem: _uiLibrary.PropTypes.func,
    onCloseLastItem: _uiLibrary.PropTypes.func
};
Promo.defaultProps = {
    baseClassName: 'p-box',
    className: null,
    title: null,
    onCloseItem: null,
    onCloseLastItem: null
};

exports.default = Promo;

/***/ }),

/***/ 169:
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./app/promo/index.js ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _uiLibrary = __webpack_require__(/*! @plesk/ui-library */ 0);

var _Promo = __webpack_require__(/*! ./Promo */ 114);

var _Promo2 = _interopRequireDefault(_Promo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var onCloseItem = function onCloseItem(_ref) {
    var hideUrl = _ref.hideUrl;

    new Ajax.Request(hideUrl, { method: 'post' });
};

module.exports = function (_ref2) {
    var container = _ref2.container,
        locale = _ref2.locale,
        props = _objectWithoutProperties(_ref2, ['container', 'locale']);

    (0, _uiLibrary.render)((0, _uiLibrary.createElement)(
        _uiLibrary.LocaleProvider,
        { messages: locale },
        (0, _uiLibrary.createElement)(_Promo2.default, _extends({}, props, { onCloseItem: onCloseItem }))
    ), container);
};

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// javascript/app/promo.js